
import { React } from 'react'
import { FullScreen, useFullScreenHandle } from 'react-full-screen'
import { MenuExportacao } from '../../../../components/MenuExportacao'
import { format, parseISO } from 'date-fns'
import { ModalDetalhes } from '../ModalDetalhes'
import { useRef } from 'react'
import { useState } from 'react'

export function GridCotacoes(props) {
    const handle = useFullScreenHandle()
    const printRef = useRef()
    const [isFullScreen, setIsFullScrenn] = useState(false)
    const [orderBy, setOrderBy] = useState('CodigoOrcamento')
    const [CodigoOrcamentoSelecionado, setCodigoOrcamentoSelecionado] = useState([])
    const [ascDesc, setAscDesc] = useState(1)

    function setFullScreen() {
        if (isFullScreen) {
            handle.exit()
            setIsFullScrenn(false)
        } else {
            handle.enter()
            setIsFullScrenn(true)
        }
    }

    function getValorSomaRegistros() {
        let soma = 0

        props.valoresCotacaoVendaFiltro
            .map(item => {
                soma += item.ValorTotal
            })

        return Intl.NumberFormat('pt-BR', { minimumFractionDigits: 2 }).format(soma)
    }

    return (
        <FullScreen handle={handle}>
            <div ref={printRef} className='useExport relative'>
                <MenuExportacao
                    filename={'Cotações'}
                    sheet={'Cotações'}
                    onlyCSV={true}
                    isFullScreen={isFullScreen}
                    setFullScreen={() => setFullScreen()}
                    idTable="table-to-xls-cotacoes"
                />
                <div
                    className={`relative mt-1 bg-gray-50  w-full ${isFullScreen && 'p-4'} shadow-lg`}
                    style={{
                        height: isFullScreen ? '100vh' : '16rem'
                    }}
                >
                    <h1 className='bg-gradient-to-r rounded-t-md from-slate-900 to-slate-700 text-white-100 font-semibold p-2'>
                        Relação de Cotações (Clique na cotação para exibir os itens)
                    </h1>
                    <div className="flex flex-col h-full">
                        <div className="overflow-auto h-full">
                            <table id="table-to-xls-cotacoes" className="border-separate table-fixed w-full">
                                <thead>
                                    <tr className="border-b-2 text-sm sticky top-0 bg-gradient-to-r from-slate-200 to-slate-100">
                                        <th className="w-16 text-center cursor-pointer" onClick={() => {
                                            setOrderBy('CodigoOrcamento')
                                            setAscDesc(ascDesc === 0 ? 1 : 0)
                                        }}>COTAÇÃO Nº</th>
                                        <th className="w-20  text-center cursor-pointer" onClick={() => {
                                            setOrderBy('DataCadastro')
                                            setAscDesc(ascDesc === 0 ? 1 : 0)
                                        }}>EMISSÃO</th>
                                        <th className="w-20  text-center cursor-pointer" onClick={() => {
                                            setOrderBy('DataStatus')
                                            setAscDesc(ascDesc === 0 ? 1 : 0)
                                        }}>FECHAMENTO</th>
                                        <th className="w-24 text-center cursor-pointer" onClick={() => {
                                            setOrderBy('Status')
                                            setAscDesc(ascDesc === 0 ? 1 : 0)
                                        }}>STATUS</th>

                                        <th className="w-36 text-center cursor-pointer" onClick={() => {
                                            setOrderBy('Vendedor')
                                            setAscDesc(ascDesc === 0 ? 1 : 0)
                                        }}>VENDEDOR</th>
                                        <th className="w-36 text-center cursor-pointer" onClick={() => {
                                            setOrderBy('AtendenteNome')
                                            setAscDesc(ascDesc === 0 ? 1 : 0)
                                        }}>ATENDENTE</th>
                                        <th className="w-36 text-center cursor-pointer" onClick={() => {
                                            setOrderBy('FormaPagto')
                                            setAscDesc(ascDesc === 0 ? 1 : 0)
                                        }}>FORMA PAGTO</th>
                                        <th className="w-24 text-center cursor-pointer" onClick={() => {
                                            setOrderBy('ValorTotal')
                                            setAscDesc(ascDesc === 0 ? 1 : 0)
                                        }}>TOTAL R$</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {props.valoresCotacaoVendaFiltro?.length > 0
                                        ? (
                                            props.valoresCotacaoVendaFiltro.sort((a, b) =>
                                                a[orderBy] > b[orderBy]
                                                    ? ascDesc === 0
                                                        ? 1
                                                        : -1
                                                    : ascDesc === 0
                                                        ? -1
                                                        : 1
                                            ).map((cotacao, key) => {
                                                return (
                                                    <tr key={key} onClick={() => setCodigoOrcamentoSelecionado(cotacao)} className="odd:bg-white-100 even:bg-gray-100 cursor-pointer hover:bg-blue-200 ">
                                                        <td className="text-sm text-center pr-1">{Intl.NumberFormat('pt-BR', { minimumFractionDigits: 0 }).format(cotacao.CodigoOrcamento)}</td>
                                                        <td className="text-sm truncate text-center">{format(parseISO(cotacao.DataCadastro), 'dd/MM/yyyy')}</td>
                                                        <td className="text-sm truncate text-center">{cotacao.DataStatus !== null ? format(parseISO(cotacao.DataStatus), 'dd/MM/yyyy') : ''}</td>
                                                        <td className={`${cotacao.Status === 'NEGOCIAÇÃO'
                                                            ? 'bg-yellow-500 text-white-100'
                                                            : cotacao.Status === 'FECHADO'
                                                                ? 'bg-green-500 text-white-100'
                                                                : cotacao.Status === 'PERDIDO'
                                                                    ? 'bg-red-500 text-white-100'
                                                                    : cotacao.Status === 'CANCELADO'
                                                                        ? 'bg-slate-500 text-white-100'
                                                                        : 'bg-white-100 text-black'} text-sm text-center`}>{cotacao.Status}</td>

                                                        <td className="text-sm text-left truncate pl-1 ">{cotacao.Vendedor?.toString().toUpperCase()}</td>
                                                        <td className="text-sm text-left truncate pl-1 ">{cotacao.AtendenteNome?.toString().toUpperCase()}</td>
                                                        <td className="text-sm text-left truncate pl-1 ">{cotacao.FormaPagto?.toString().toUpperCase()}</td>
                                                        <td className="text-sm text-right">{Intl.NumberFormat('pt-BR', { minimumFractionDigits: 2 }).format(cotacao.ValorTotal)}</td>
                                                    </tr>
                                                )
                                            })
                                        )
                                        : (
                                            <tr className="text-center">
                                                <td className="p-3 italic" colSpan={8}>
                                                    Sem registros
                                                </td>
                                            </tr>
                                        )}
                                </tbody>
                            </table>
                        </div>

                        <div className="bg-white-100 flex-row justify-between  p-2 border-t-2 flex align-middle  bg-gradient-to-r from-slate-200 to-slate-100">
                            <p className="text-sm font-bold">
                                Total = {props.valoresCotacaoVendaFiltro?.length.toLocaleString('en-US', { minimumFractionDigits: 0 }).replace(',', '.')}
                            </p>
                            <p className="text-sm font-semibold ">
                                Soma = R$ {getValorSomaRegistros()}
                            </p>
                        </div>
                    </div>

                    <ModalDetalhes
                        setCodigoOrcamentoSelecionado={setCodigoOrcamentoSelecionado}
                        registro={CodigoOrcamentoSelecionado}
                        RegistrosProdutos={props.RegistrosProdutos}
                    />
                </div>
            </div>
        </FullScreen>
    )
}
